import TextField from "@/atoms/TextField";
import Button from "@/atoms/Button";

const DefaultBilling = ({ defaultMethod = {}, onClickUpdate }) => {
  const { description } = defaultMethod;
  return (
    <div>
      <TextField
        name={"method"}
        value={description}
        label={"Payment Method"}
        disabled
      />
      <div className={"flex justify-end"}>
        <Button
          className={"float-right"}
          level={"secondary"}
          label={"Update Payment Method"}
          onClick={onClickUpdate}
        />
      </div>
    </div>
  );
};

export default DefaultBilling;
